<template>
  <Navbar />
</template>
<script>
import Navbar from "@/components/AllNavBar.vue";
import store from "@/store";
export default {
  components: { Navbar },
  data() {
    return {
      r3: JSON.parse(store.state.randp.r3).create,
    };
  },
  async mounted() {
    if (this.r3 != true) {
      this.$root.$router.push({
        path: "/SignIn",
      });
    }
  },

  methods: {},
  watch: {},
};
</script>